import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "../Auth/auth.service";
import * as i2 from "@angular/router";
export class AuthGuardService {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.authService.getToken()) {
                return true;
            }
            yield this.router.navigate(['login']);
            return false;
        });
    }
}
AuthGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router)); }, token: AuthGuardService, providedIn: "root" });
